import EmailCampaignToken from '@apps/campaigns/admin/tokens/campaign/email'
import New from '@apps/campaigns/admin/views/email/new'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Email Campaigns)',
  access: { rights: { $oneOf: ['campaigns:view_email_campaigns','campaigns:manage_email_campaigns'] } },
  collection: {
    endpoint: '/api/admin/campaigns/email',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (email_campaign) => (
        <EmailCampaignToken email_campaign={ email_campaign } compact={ true } />
      ) }
    ],
    empty: {
      svg: 'mail',
      title: 't(No Email Campaigns)',
      text: 't(You have not yet created any email campaigns for this webinar)',
      buttons: [
        { 
          label: 't(Create Email Campaign)', 
          access: { rights: { $oneOf: ['campaigns:manage_email_campaigns'] } },
          modal: <New webinar={ props.webinar } /> 
        }
      ]
    },
    entity: 'email campaign',
    defaultQuery: { webinar_id: props.webinar.id },
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/campaigns/email/${record.id}`)
  },
  task: {
    svg: 'plus',
    tooltip: 't(Create Email Campaign)', 
    access: { rights: { $oneOf: ['campaigns:manage_email_campaigns'] } },
    modal: <New webinar={ props.webinar } />
  }
})

export default Panel(null, mapPropsToPanel)
